export const SET_FINGERPRINT = 'SET_FINGERPRINT'
export const SET_WEB_VIEW = 'SET_WEB_VIEW'
export const SET_CLIENT_TYPE = 'SET_CLIENT_TYPE'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_DRIVER = 'SET_DRIVER'
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT'
export const SET_LOADING_PROGRESS = 'SET_LOADING_PROGRESS'
export const SET_OFFLINE = 'SET_OFFLINE'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
export const SET_AVAILABILITY = 'SET_AVAILABILITY'
export const SET_MAP_OPTIONS = 'SET_MAP_OPTIONS'
export const SET_STATUS = 'SET_STATUS'
